"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "InputField", {
  enumerable: true,
  get: function get() {
    return _Input.InputField;
  }
});
Object.defineProperty(exports, "SelectField", {
  enumerable: true,
  get: function get() {
    return _Select.SelectField;
  }
});
Object.defineProperty(exports, "CheckboxField", {
  enumerable: true,
  get: function get() {
    return _Checkbox.CheckboxField;
  }
});
Object.defineProperty(exports, "CheckboxGroupField", {
  enumerable: true,
  get: function get() {
    return _CheckboxGroup.CheckboxGroupField;
  }
});
Object.defineProperty(exports, "RadioGroupField", {
  enumerable: true,
  get: function get() {
    return _RadioGroup.RadioGroupField;
  }
});
Object.defineProperty(exports, "TextAreaField", {
  enumerable: true,
  get: function get() {
    return _TextArea.TextAreaField;
  }
});
Object.defineProperty(exports, "LogicalSelectField", {
  enumerable: true,
  get: function get() {
    return _LogicalSelect.LogicalSelectField;
  }
});
Object.defineProperty(exports, "TogglesField", {
  enumerable: true,
  get: function get() {
    return _Toggles.TogglesField;
  }
});
Object.defineProperty(exports, "FileInputField", {
  enumerable: true,
  get: function get() {
    return _FileInput.FileInputField;
  }
});
Object.defineProperty(exports, "FieldSet", {
  enumerable: true,
  get: function get() {
    return _FieldSet["default"];
  }
});
Object.defineProperty(exports, "Field", {
  enumerable: true,
  get: function get() {
    return _Field["default"];
  }
});
exports["default"] = void 0;

var _Form = _interopRequireDefault(require("./Form"));

var _Input = require("./Input");

var _Select = require("./Select");

var _Checkbox = require("./Checkbox");

var _CheckboxGroup = require("./CheckboxGroup");

var _RadioGroup = require("./RadioGroup");

var _TextArea = require("./TextArea");

var _LogicalSelect = require("./LogicalSelect");

var _Toggles = require("./Toggles");

var _FileInput = require("./FileInput");

var _FieldSet = _interopRequireDefault(require("./FieldSet"));

var _Field = _interopRequireDefault(require("./Field"));

/**
This file only deals re-exporting and adding
the wrapped fields to the Form as properties.
These exports are deprecated in lieu of named exports from the root
**/
// wrapped components
// unwrapped components
_Form["default"].Input = _Input.InputField;
_Form["default"].Select = _Select.SelectField;
_Form["default"].LogicalSelect = _LogicalSelect.LogicalSelectField;
_Form["default"].RadioGroup = _RadioGroup.RadioGroupField;
_Form["default"].TextArea = _TextArea.TextAreaField;
_Form["default"].Checkbox = _Checkbox.CheckboxField;
_Form["default"].CheckboxGroup = _CheckboxGroup.CheckboxGroupField;
_Form["default"].Toggles = _Toggles.TogglesField;
_Form["default"].FileInput = _FileInput.FileInputField;
_Form["default"].FieldSet = _FieldSet["default"];
_Form["default"].Field = _Field["default"];
var _default = _Form["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Form/index.js
// module id = 488
// module chunks = 0